import { render, staticRenderFns } from "./CardDrag.vue?vue&type=template&id=2ac08cb8"
import script from "./CardDrag.vue?vue&type=script&lang=js"
export * from "./CardDrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac08cb8')) {
      api.createRecord('2ac08cb8', component.options)
    } else {
      api.reload('2ac08cb8', component.options)
    }
    module.hot.accept("./CardDrag.vue?vue&type=template&id=2ac08cb8", function () {
      api.rerender('2ac08cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/CardDrag.vue"
export default component.exports